import { fromJS, Map } from 'immutable';

import {
  SET_REGISTRATION_INFO,
  RESET_REGISTRATION_INFO,
  SET_REGISTRATION_CURRENT_STEP,
  SIGN_UP,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  RESET_REGISTRATION_STATE,
} from '../actions/actionTypes';

const initialState = fromJS({
  info: {},
  currentStep: 0,
  isSubmitting: false,
});
// {
//   info: {
//     'custom:buildingLicExpMask': '30-04-2021',
//     'custom:employeesCount': '786',
//     'custom:personalPhone': '+61298765432',
//     'custom:materialLocation': 'Enim nemo voluptas q',
//     'custom:buildingLicNo': '256',
//     'custom:businessAddress': 'Adelaide SA, Australia',
//     'custom:businessYears': '703',
//     'custom:serviceAType': 'national',
//     'custom:firstName': 'Justine',
//     'custom:surname': 'Blanchard',
//     'custom:position': 'Ea enim itaque nemo ',
//     'custom:personalEmail': 'sanifss+additional@gmail.com',
//     'custom:profileHeadline': 'Cillum ullam ullam deleniti ab sint qui et accusantium modi eum voluptatem eaque anim eligendi tenetur officia nihil amet dolores',
//     'custom:buildingLicExp': '2021-04-29T18:30:00.000Z',
//     'custom:businessName': 'Vernon Kirkland',
//     'custom:roleType': 'B',
//     legal: true,
//     password: 'Pa$$w0rd!',
//     'custom:marketingOptIn': true,
//     'custom:newBuildsPerYear': '11-20'
//   }
// }
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REGISTRATION_INFO:
      return state.set('info', fromJS(action.info));
    case RESET_REGISTRATION_INFO:
      return state.set('info', Map({})).set('currentStep', 0);
    case SET_REGISTRATION_CURRENT_STEP:
      return state.set('currentStep', action.step);
    case SIGN_UP:
      return state.set('isSubmitting', true);
    case SIGN_UP_SUCCESS:
      return state
        .set('isSubmitting', false)
        .set('currentStep', 2)
        .setIn(['info', 'password'], '');
    case SIGN_UP_FAILURE:
      return state.set('isSubmitting', false);
    case RESET_REGISTRATION_STATE:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
